module.exports = __webpack_public_path__ + "img/extended.6ac93625.png";